var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabRf = function SvgTabRf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4145",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1020.4)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path4693",
    cx: 16,
    cy: 1036.4,
    r: 3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4700",
    fill: "currentColor",
    d: "M4.691 4.691A15.95 15.95 0 0 0 0 16.001a15.95 15.95 0 0 0 4.691 11.308l1.405-1.404A13.96 13.96 0 0 1 2 16.001c0-3.872 1.564-7.373 4.096-9.905L4.69 4.692zm22.617 0-1.404 1.405A13.96 13.96 0 0 1 30 16c0 3.872-1.564 7.372-4.096 9.904l1.404 1.405C30.205 24.412 32 20.412 32 15.999s-1.795-8.411-4.692-11.308zM7.52 7.52C5.346 9.692 4 12.692 4 16s1.347 6.307 3.52 8.48l1.405-1.404A9.97 9.97 0 0 1 6 16a9.97 9.97 0 0 1 2.924-7.076zm16.961 0-1.404 1.404C24.884 10.732 26 13.233 26 16s-1.116 5.268-2.924 7.076l1.404 1.404C26.653 22.307 28 19.309 28 16s-1.347-6.307-3.52-8.48m-14.133 2.828a7.975 7.975 0 0 0 0 11.304l1.405-1.404C10.667 19.164 10 17.663 10 16s.667-3.162 1.752-4.246zm11.305 0-1.404 1.406C21.332 12.838 22 14.337 22 16s-.668 3.164-1.752 4.248l1.404 1.404a7.975 7.975 0 0 0 0-11.304",
    color: "currentColor",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    style: {
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal",
      textDecorationColor: "#474747",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textTransform: "none",
      whiteSpace: "normal"
    },
    transform: "translate(0 1020.4)"
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle4744",
    cx: -32.348,
    cy: 1036.4,
    r: 3,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "circle4746",
    cx: -32.348,
    cy: 1036.4,
    r: 15,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "circle4748",
    cx: -32.348,
    cy: 1036.4,
    r: 11,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "circle4750",
    cx: -32.348,
    cy: 1036.4,
    r: 7,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabRf);
export default ForwardRef;